export default "__VITE_ASSET__CqLU52D4__ 500w";